import {
  withProps,
  compose,
  branch,
  renderComponent,
  withHandlers,
  withState,
  lifecycle,
} from 'recompose';
import { connect } from 'react-redux';
import { get } from 'lodash';
import PaymentForm from '../components/PaymentFormPayFac';
import WithToggle from '../../hoc/WithToggle';
import PaymentFormApplePay from '../components/PaymentFormApplePay';
import { applePaySession } from '../../utils/applePay';
import withRouteParameters from './withRouteParameters';
import { getShopCountry, getShopCurrency } from '../../shops/selectors';
import withPayFacInput from './withPayFacInput';
import PayFac from '../../utils/payFac';
import { getAppointmentId, getIsValidatingAppointment } from '../selectors';
import analytics
  from '../../applicationServices/analytics/BookingAnalytics';

const mapStateToProps = (state, props) => {
  const areWeOnChargeAppointment = getAppointmentId(state);
  const hasApplePay = state.app.applePay && !props.disableApplePay;
  return {
    hasApplePay,
    currency: getShopCurrency(state, props.shopRoute),
    shopCountry: getShopCountry(state, props.shopRoute),
    areWeOnChargeAppointment: getAppointmentId(state),
    initialState: hasApplePay && areWeOnChargeAppointment,
    isValidating: getIsValidatingAppointment(state),
  };
};

const showSwalError = (error) => {
  window.swal({
    title: 'Error',
    text: get(error, 'message', ''),
    type: 'error',
    confirmButtonColor: '#dd6b55',
  });
};

export default compose(
  withRouteParameters,
  connect(mapStateToProps),
  WithToggle,
  withState('processing', 'setProcessing', false),
  withProps(props => ({
    toggleApplePay: props.toggle,
    formDisabled: props.formDisabled || props.processing || props.isValidating,
  })),
  withHandlers({
    handleProcessingError: props => (error) => {
      props.setProcessing(false);
      showSwalError(error);
    },
  }),
  withHandlers({
    onClick: props => () => {
      props.setProcessing(true);
      applePaySession(
        props.amount,
        props.currency,
        async (result) => {
          analytics.fillCardInfo({ source: 'squire_modal', isApplePay: true });
          const setupResponse = await props.confirmSetup(result.token);
          props.setProcessing(false);
          return setupResponse;
        },
        props.handleProcessingError,
        () => props.setProcessing(false),
      );
    },
  }),
  branch(props => props.toggled, renderComponent(PaymentFormApplePay)),
  withPayFacInput({}),
  withState('submitEnabled', 'setSubmitEnabled', false),
  withHandlers({
    submit: props => async (e) => {
      e.preventDefault();

      props.setProcessing(true);
      let token = null;

      if (!(props.isCoveredByDiscount)) {
        const payFac = new PayFac();
        props.setPayFacInputsDisabled(true);

        try {
          const result = await payFac.createToken({
            cardNumber: props.cardNumber,
            expiry: props.cardExpiry,
            cvc: props.cardCvc,
            zipCode: props.zipCode,
          });
          token = { id: result.token };
        } catch (error) {
          props.handleProcessingError(error);
          props.setProcessing(false);
          return;
        } finally {
          props.setPayFacInputsDisabled(false);
        }
      }
      try {
        await props.confirmSetup(token);
      } catch (error) {
        props.handleProcessingError(error);
      } finally {
        props.setProcessing(false);
      }
    },
    setCardNumber: props => (event) => {
      props.onCardNumberChange(event.target.value, true);
    },
    cardNumberBlur: props => (event) => {
      props.onCardNumberChange(event.target.value);
    },
    setCardExpiry: props => (event) => {
      props.onCardExpiryChange(event.target.value, true);
    },
    cardExpiryBlur: props => (event) => {
      props.onCardExpiryChange(event.target.value);
    },
    setCardCvc: props => (event) => {
      props.onCardCvcChange(event.target.value, true);
    },
    cardCvcBlur: props => (event) => {
      props.onCardCvcChange(event.target.value);
    },
    setZipCode: props => (event) => {
      props.setZipCode(event.target.value);
      props.validateZipCode(event.target.value);
    },
    zipCodeBlur: props => () => {
      if (!props.hasErrors) {
        if (props.zipCode) {
          analytics.fillCardInfoField('cardZipCode');
        }
        analytics.fillCardInfo({ source: 'squire_modal' });
      }
    },
  }),
  lifecycle({
    componentDidUpdate(prevProps) {
      if (this.props.cardNumber) {
        if (prevProps.isCoveredByDiscount !== this.props.isCoveredByDiscount) {
          this.props.setPayFacInputsDisabled(this.props.isCoveredByDiscount);
        }
      }

      if (
        this.props.cardNumber !== '' &&
        this.props.cardExpiry !== '' &&
        this.props.cardCvc !== '' &&
        this.props.zipCode !== '' &&
        this.props.submitEnabled === false
      ) {
        this.props.setSubmitEnabled(true);
      }
    },
  }),
)(PaymentForm);



// WEBPACK FOOTER //
// ./src/app/reservation/containers/PaymentFormContainerPayFac.js